module.exports = __webpack_public_path__ + "static/media/main idea.2b022e03.mp3";